/**
 * Safari throws NotAllowedError when a passkey sheet is dismissed, or when
 * the platform refuses the prompt. That is not an application failure.
 *
 * @param {unknown} err
 * @returns {boolean}
 */
export function isPasskeyDismissal(err) {
  if (!err || typeof err !== 'object') return false;
  const name = 'name' in err ? String(err.name || '') : '';
  const message = String(err.message || err.error_message || '');
  return (
    name === 'NotAllowedError' ||
    name === 'AbortError' ||
    /not allowed by the user agent/i.test(message)
  );
}
